import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

import { ClientAccess } from '@core-interactions/models/client-access';
import { SortPipe } from '@shared/pipes/sort.pipe';

@Component({
  selector: 'app-client-picker',
  templateUrl: './client-picker.component.html',
  styleUrls: ['./client-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatMenuModule, NgClass, SortPipe]
})
export class ClientPickerComponent {
  readonly clients = input<ClientAccess[]>([]);
  readonly selectedClientId = input<string>();

  readonly selected = output<ClientAccess>();

  onClientChange(client: ClientAccess): void {
    this.selected.emit(client);
  }
}
